import React, { ReactHTML } from 'react';
import { ReactComponent as CheckIcon } from '../../../../../assets/checkicon.svg';
import useCircleCheckBoxStyles from './themes';

type Props = {
  label: string;
  isChecked: boolean;
  setEnd: React.Dispatch<React.SetStateAction<string>>;
};

const CircleCheckbox = (props: Props) => {
  const { label, isChecked, setEnd } = props;
  const classes = useCircleCheckBoxStyles();
  const handleChange = () => {
    if (isChecked) {
      setEnd('');
    }
  };
  return (
    <label htmlFor={label} className={classes.checkbox}>
      {label}
      <input
        defaultChecked={isChecked}
        checked={isChecked}
        onChange={handleChange}
        id={label}
        type="checkbox"
      />
      <span className={classes.checkmark}>{isChecked && <CheckIcon />}</span>
    </label>
  );
};

export default CircleCheckbox;
